import {
  GroupIcon,
  CoursesIcon,
  DasboardIcon,
  GradesIcon,
  ReportsIcon,
  SettingsIcon,
  StudyIcon,
  SpacesIcon,
} from '@/assets/nav';

// Define the types for navigation items
export interface NavItem {
  name: string;
  route: string;
  subItems?: SubNavItem[];
  icon?: any;
}

export interface SubNavItem {
  name: string;
  route: string;
}

// Adjust NavItemMap to use the NavItem type
export const NavItemMap: Record<string, Array<NavItem>> = {
  student: [
    { name: 'Dashboard', route: '/student', icon: DasboardIcon },
    { name: 'Course', route: '/student/course', icon: CoursesIcon },
    { name: 'Study', route: '/student/study', icon: StudyIcon },
    { name: 'Lesson', route: '/student/lesson' },
    { name: 'Flash Cards', route: '/student/study/flashcards' },
    { name: 'Flash Cards Review', route: '/student/study/flashcards/review' },
    { name: 'Self Quiz', route: '/student/study/self-quiz' },
    { name: 'Self Quiz Review', route: '/student/study/self-quiz/review' },
    { name: 'Tutor Me', route: '/student/study/tutor-me' },
    { name: 'Spaces', route: '/student/spaces', icon: SpacesIcon },
  ],
  instructor: [
    { name: 'Home', route: '/admin', icon: DasboardIcon },
    { name: 'Group', route: '/admin/group', icon: GroupIcon },
    {
      name: 'Courses',
      route: '/admin/',
      icon: CoursesIcon,
      subItems: [
        { name: 'All Courses', route: '/admin/courses' },
        { name: 'Assistiv Docs', route: '/admin/courses/assistiv-docs' },
        { name: 'Assistiv Flow', route: '/admin/courses/assistiv-flow' },
        {
          name: 'Assistiv Docs Edit',
          route: '/admin/courses/assistiv-docs/edit',
        },
      ],
    },
    {
      name: 'Reports',
      route: '/admin/',
      icon: ReportsIcon,
      subItems: [
        { name: 'Group Overview', route: '/admin/reports' },
        { name: 'Transcripts', route: '/admin/transcripts' },
      ],
    },
    { name: 'Grades', route: '/admin/grades', icon: GradesIcon },
    { name: 'Grader', route: '/admin/grades/grader' },
    {
      name: 'System Setup',
      route: '/admin/system-setup',
      icon: SettingsIcon,
      subItems: [{ name: 'User Registration', route: '/admin/system-setup/user-registration' }],
    },
  ],
  enterprise_admin: [
    { name: 'Home', route: '/admin', icon: DasboardIcon },
    { name: 'Group', route: '/admin/group', icon: GroupIcon },
    {
      name: 'Courses',
      route: '/admin/',
      icon: CoursesIcon,
      subItems: [
        { name: 'All Courses', route: '/admin/courses' },
        { name: 'Assistiv Docs', route: '/admin/courses/assistiv-docs' },
        { name: 'Assistiv Flow', route: '/admin/courses/assistiv-flow' },
        {
          name: 'Assistiv Docs Edit',
          route: '/admin/courses/assistiv-docs/edit',
        },
      ],
    },
    { name: 'Grades', route: '/admin/grades', icon: GradesIcon },
    { name: 'Transcripts', route: '/admin/transcripts', icon: ReportsIcon },
    { name: 'Grader', route: '/admin/grades/grader' },
    {
      name: 'System Setup',
      route: '/admin/system-setup',
      icon: SettingsIcon,
      subItems: [
        { name: 'SAML 2.0 SSO', route: '/admin/system-setup/saml-setup' },
        { name: 'Pending Admin Accounts', route: '/admin/system-setup/admin-queue' },
        { name: 'User Registration', route: '/admin/system-setup/user-registration' },
      ],
    },
  ],
};

export const NavItemHideList: Record<string, Array<string>> = {
  student: [
    'Lesson',
    'Flash Cards',
    'Flash Cards Review',
    'Self Quiz Review',
    'Self Quiz',
    'Tutor Me',
  ],
  instructor: ['Grader', 'Assistiv Docs Edit'],
  enterprise_admin: ['Grader', 'Assistiv Docs Edit'],
};
